"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isUrl = void 0;
exports.isBrowser = isBrowser;
exports.isMobile = isMobile;
exports.isJSONStr = isJSONStr;
exports.isPhoneNumber = isPhoneNumber;
exports.isEmail = isEmail;
exports.isEmpty = isEmpty;
const reg = /(((^https?:(?:\/\/)?)(?:[-;:&=\+\$,\w]+@)?[A-Za-z0-9.-]+(?::\d+)?|(?:www.|[-;:&=\+\$,\w]+@)[A-Za-z0-9.-]+)((?:\/[\+~%\/.\w-_]*)?\??(?:[-\+=&;%@.\w_]*)#?(?:[\w]*))?)$/;
const isUrl = (path) => reg.test(path);
exports.isUrl = isUrl;
function isBrowser() {
    if (typeof window === 'undefined') {
        return false;
    }
    return true;
}
function isMobile() {
    return /phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone|webOS|android/i.test(navigator.userAgent);
}
function isJSONStr(text) {
    if (typeof text !== 'string') {
        return false;
    }
    try {
        const json = JSON.parse(text);
        return typeof json === 'object';
    }
    catch (error) {
        return false;
    }
}
function isPhoneNumber(num = '') {
    return /^1(3|4|5|6|7|8|9)\d{9}$/.test(num);
}
function isEmail(num = '') {
    return /^\w+((-\w+)|(\.\w+))*\@[A-Za-z0-9]+((\.|-)[A-Za-z0-9]+)*\.[A-Za-z0-9]+$/.test(num);
}
function isEmpty(value) {
    if (value === null || value === undefined)
        return true;
    if (typeof value === 'number' || typeof value === 'boolean')
        return false;
    if (Array.isArray(value)) {
        return value.length === 0;
    }
    if (typeof value === 'object') {
        return Object.keys(value).length === 0;
    }
    if (typeof value === 'string') {
        return value.length === 0;
    }
    return false;
}
//# sourceMappingURL=validate.js.map